{
  "$schema": "https://json-schema.org/draft/2020-12/schema",
  "title": "ServiceTabs",
  "type": "object",
  "additionalProperties": false,
  "required": [
    "title",
    "highlight",
    "items"
  ],
  "properties": {
    "title": {
      "title": "Title",
      "type": "string",
      "maxLength": 120
    },
    "highlight": {
      "title": "Highlighted title part",
      "type": "string",
      "maxLength": 120
    },
    "items": {
      "title": "Tabs",
      "type": "array",
      "maxItems": 12,
      "x-ui": "list",
      "x-itemTitle": "heading",
      "items": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "key",
          "tabLabel",
          "heading",
          "bodyHtml",
          "bullets"
        ],
        "properties": {
          "key": {
            "title": "Anchor id",
            "type": "string",
            "pattern": "^[A-Za-z0-9_-]{1,40}$"
          },
          "iconMediaId": {
            "title": "Icon",
            "type": [
              "string",
              "null"
            ],
            "pattern": "^[0-9a-fA-F-]{36}$",
            "x-ui": "media"
          },
          "tabLabel": {
            "title": "Tab label (new line = second row)",
            "type": "string",
            "maxLength": 80,
            "x-ui": "textarea"
          },
          "heading": {
            "title": "Heading",
            "type": "string",
            "maxLength": 160
          },
          "bodyHtml": {
            "title": "Text",
            "type": "string",
            "maxLength": 4000,
            "x-ui": "richtext"
          },
          "bullets": {
            "title": "Bullet points",
            "type": "array",
            "maxItems": 12,
            "x-ui": "stringList",
            "items": {
              "type": "string",
              "maxLength": 200
            }
          },
          "imageMediaId": {
            "title": "Image",
            "type": [
              "string",
              "null"
            ],
            "pattern": "^[0-9a-fA-F-]{36}$",
            "x-ui": "media"
          },
          "buttonLabel": {
            "title": "Button label",
            "type": "string",
            "maxLength": 60
          },
          "buttonHref": {
            "title": "Button link",
            "type": "string",
            "maxLength": 500,
            "pattern": "^(|page:[0-9a-fA-F-]{36}|/[^\\s]*|https?://[^\\s]+|mailto:[^\\s]+|tel:[+0-9 ]+|#[A-Za-z0-9_-]*)$",
            "x-ui": "link"
          }
        }
      }
    }
  }
}
